import { render } from "./sch_request.vue?vue&type=template&id=082cf8e0&scoped=true"
import script from "./sch_request.vue?vue&type=script&lang=js"
export * from "./sch_request.vue?vue&type=script&lang=js"

import "./sch_request.vue?vue&type=style&index=0&id=082cf8e0&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082cf8e0"]])

export default __exports__